import { StyleSheet } from 'react-native';
import App from 'constants/App';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#FFFFFF',
  },
  header: {
    flexDirection: 'row',
    marginBottom: 50,
  },
  headerSmall: {
    flexDirection: 'row',
    padding: 10,
  },
  iconLarge: {
    flex: 0.1,
    alignSelf: 'center',
  },
  iconSmall: {
    flex: 0.5,
    alignSelf: 'center',
  },
  upperTextContainerLarge: {
    flexDirection: 'column',
    alignSelf: 'flex-end',
    marginTop: 45,
  },
  textTitleLarge: {
    flex: 0.2,
    color: '#000000',
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'flex-start',
    fontSize: 22,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  textSmall: {
    flex: 1,
    marginLeft: '3%',
    alignSelf: 'center',
    justifyContent: 'center',
    color: '#001639',
    fontSize: 18,
    fontWeight: '700',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'left',
  },
  wrapper: {
    width: '90%',
    marginHorizontal: 'auto',
  },
  wrapperSmall: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  selectLabel: {
    lineHeight: 24,
    fontWeight: '500',
    fontSize: 16,
    marginBottom: 10,
  },
  dateInputContainer: {
    width: '100%',
    marginTop: 10,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  topRowTextForDescription: {
    fontSize: 14,
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0,
    textAlign: 'center',
    color: '#FFFFFF',
  },
  datesErrorContainer: {
    flexDirection: 'column',
    alignSelf: 'center',
  },
  textError: {
    color: App.errorColor,
  },
  scrollItemsContainer: {
    flexDirection: 'column',
  },
  scrollItemsContentContainer: {
    width: '80%',
    marginHorizontal: 'auto',
  },
  switchesContainer: {
    flexDirection: 'column',
    marginVertical: 15,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  switch: {
    alignSelf: 'center',
    marginTop: 0,
    width: '20%',
  },
  switchTitle: {
    fontSize: 15,
    color: '#001639',
    fontWeight: '400',
    lineHeight: 20,
    letterSpacing: 0.25,
    width: 200
  },
  switchContainer: {
    flexDirection: 'row',
    marginVertical: 6,
    marginLeft: 10,
    width: 300
  },
  toggle: {
    borderWidth: 2,
    borderRadius: 25,
    paddingVertical: 8,
    paddingHorizontal: 16,
    marginHorizontal: 6,
    marginVertical: 4,
  },
  text: {
    fontWeight: '600',
    fontSize: 13,
    textAlign: 'center',
  },
    registerOrderButtonContainerLarge: {
    width: '50%',
    marginTop: 25,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  registerOrderButtonContainerSmall: {
    marginVertical: 15,
    flexDirection: 'row',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  orderBtnContainerLarge: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  orderBtnContainerSmall: {
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: '1%',
  },
  btnTitleOrders: {
    color: '#001C47',
    fontSize: 16,
    fontWeight: '500',
    lineHeight: 20,
    letterSpacing: 0.25,
    textAlign: 'center',
    paddingVertical: 6,
    paddingHorizontal: 6,
  },
  orderBtnLarge: {
    backgroundColor: '#EEEEEE',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
  orderBtnSmall: {
    backgroundColor: '#EEEEEE',
    borderRadius: 10,
    alignSelf: 'center',
    width: '100%',
  },
});
